import { get, pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes?.style;

  const getShadow = () => {
    if (!attributes.shadow) return {};

    return {
      shadowColor: attributes.shadow.color,
      shadowRadius: attributes.shadow.size,
      shadowOpacity: attributes.shadow.blur || 1,
      shadowOffset: {
        width: attributes.shadow.x,
        height: attributes.shadow.y,
      },
      elevation:
        attributes?.shadow?.size === 0
          ? attributes?.shadow?.x
          : attributes?.shadow?.size,
    };
  };

  const minHeight =
    get(style, 'height') ??
    get(attributes, 'attributes.height') ??
    get(attributes, 'height', 0);

  return StyleSheet.create({
    container: {
      ...getShadow(),
      minHeight,
      zIndex: attributes.style?.zIndex || attributes.zIndex,
      ...(isV4
        ? pick(style, [
            'top',
            'left',
            'bottom',
            'right',
            'position',
            'transform',
            'width',
            'height',
            'margin',
            'marginTop',
            'marginRight',
            'marginBottom',
            'marginLeft',
          ])
        : pick(attributes, ['marginTop', 'marginLeft', 'width'])),
    },
  });
};

export default createStyles;
